var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRedAgent14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2038 35.4756L7.37893 31.3034C5.14801 30.1168 3.28239 28.3451 1.98238 26.1783C0.682363 24.0115 -0.0029524 21.5316 9.56071e-06 19.0048V2.53397C9.56071e-06 1.86192 0.266981 1.21739 0.742192 0.742183C1.2174 0.266971 1.86193 0 2.53398 0H27.8737C28.5457 0 29.1903 0.266971 29.6655 0.742183C30.1407 1.21739 30.4076 1.86192 30.4076 2.53397V19.0048C30.4106 21.5316 29.7253 24.0115 28.4253 26.1783C27.1253 28.3451 25.2597 30.1168 23.0287 31.3034L15.2038 35.4756ZM2.53398 2.53397V19.0048C2.53257 21.0721 3.09383 23.1008 4.15759 24.8735C5.22136 26.6461 6.74751 28.0958 8.57243 29.0672L15.2038 32.6033L21.8352 29.0684C23.6603 28.097 25.1866 26.6471 26.2504 24.8742C27.3142 23.1013 27.8753 21.0723 27.8737 19.0048V2.53397H2.53398Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2039 29.4928V5.06915H25.3398V18.7589C25.3397 20.3649 24.9036 21.9406 24.078 23.3181C23.2523 24.6955 22.0682 25.8229 20.6519 26.58L15.2039 29.4928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedAgent14);
export default __webpack_public_path__ + "static/media/icon-red-agent-14.a670ae9f213f5169d4ba7349dc1c9d91.svg";
export { ForwardRef as ReactComponent };